import styled from "styled-components";


export const NFTTabsContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`
export const NFTTabsHeader = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //padding: 0 20px;

    span {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 4px solid ${({ theme }) => theme.newBg3};
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
            background-color: ${({ theme }) => theme.newBg3};
            transform: scale(0.99);
        }
        &.active {
            border-bottom: 4px solid ${({ theme }) => theme.yetiBlue};
        }
    }
`

export const NFTTabsContent = styled.div`
    height: calc(100% - 52px);
    width: 100%;
    padding: 1rem;
    overflow: hidden;

    &.noHeader {
        height: unset;
        padding: 0;
    }
`
